module.exports = __webpack_public_path__ + "static/media/Exams-rafiki.2424f6f5.png";